import React, { useMemo } from "react";

const ServicesPillars = () => {
  const pillars = useMemo(
    () => [
      {
        title: "Training",
        desc: "Workshops and coaching that build disciplined problem-solving and execution.",
        icon: (
          <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none">
            <path d="M4 6H20V16H4V6Z" stroke="var(--brand)" strokeWidth="2" />
            <path d="M8 20H16" stroke="var(--brand-accent)" strokeWidth="2" />
          </svg>
        )
      },
      {
        title: "Consulting",
        desc: "Quality system and performance support to reduce defects and stabilize outcomes.",
        icon: (
          <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none">
            <path d="M4 18V6" stroke="var(--brand)" strokeWidth="2" />
            <path d="M8 14L12 10L16 13L20 7" stroke="var(--brand-accent)" strokeWidth="2" />
          </svg>
        )
      },
      {
        title: "Compliance",
        desc: "Audit-ready alignment across documentation, governance, and standard work.",
        icon: (
          <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none">
            <path d="M6 4H18V20H6V4Z" stroke="var(--brand)" strokeWidth="2" />
            <path d="M9 12L11 14L15 9" stroke="var(--brand-accent)" strokeWidth="2" />
          </svg>
        )
      }
    ],
    []
  );

  return (
    <section className="w-full bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <h2 className="text-3xl font-semibold text-[color:var(--navy)]">
          Our core service pillars
        </h2>

        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {pillars.map((p) => (
            <div
              key={p.title}
              className="group rounded-2xl border border-[color:var(--border)] bg-[color:var(--surface)] p-8 transition hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="flex items-center gap-4">
                <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-white border border-[color:var(--border)] shadow-sm group-hover:scale-105 transition">
                  {p.icon}
                </div>
                <div className="text-xl font-semibold text-[color:var(--navy)]">
                  {p.title}
                </div>
              </div>

              <p className="mt-4 text-sm text-[color:var(--muted)] leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesPillars;
